import React from 'react';

interface RealizacaoFormProps {
	values?: any
	onSubmit: (event: any) => void
}

const RealizacaoForm = React.forwardRef((props: RealizacaoFormProps, ref: React.Ref<any>) => {
	const submitForm = React.useCallback(() => {
		document.getElementById('realizacao_estagio_form_submit')?.click();
	}, []);

	const resetForm = React.useCallback(() => {
		document.getElementById('realizacao_estagio_form_reset')?.click();
	}, []);

	React.useImperativeHandle(ref, () => ({
		submit: submitForm,
		reset: resetForm,
	}), [resetForm, submitForm]);

	const onSubmit = React.useCallback((event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		event.stopPropagation();

		const form = event.target as HTMLFormElement;
		const formData = new FormData(form);
		const formValues = Object.fromEntries(formData);

		// eslint-disable-next-line @typescript-eslint/naming-convention
		const { carga_horaria_realizada_horas, carga_horaria_realizada_minutos, ultimo_dia_em_campo, ...values } = formValues;

		// eslint-disable-next-line @typescript-eslint/naming-convention
		const horas = Number(carga_horaria_realizada_horas);
		const minutos = Math.round((Number(carga_horaria_realizada_minutos) / 60) * 10000) / 10000;

		values.carga_horaria_realizada = Number(horas + minutos).toString();

		if (ultimo_dia_em_campo && typeof ultimo_dia_em_campo === 'string') {
			const date = new Date(`${ultimo_dia_em_campo}T00:00:00-0300`).setHours(23, 59, 59, 999);
			values.ultimo_dia_em_campo = (new Date(date).toISOString());
		}

		props.onSubmit(values);
	}, [props]);

	return (
		<form id="realizacao_estagio_form" onSubmit={onSubmit}>
			<div className='row'>
				<div className='col-md-6'>
					<div className='form-group'>
						<label htmlFor='ultimo_dia_em_campo'>Último dia em campo</label>
						<input
							id="ultimo_dia_em_campo"
							name="ultimo_dia_em_campo"
							type='date'
							className='form-control'
							required
							max={new Date().toISOString().split('T')[0]}
							defaultValue={props.values?.ultimo_dia_em_campo || ''}
						/>
					</div>
				</div>

				<div className='col-md-6'>
					<div className='form-group'>
						<label htmlFor='carga_horaria_realizada_horas'>Carga horária realizada</label>
						<div className="input-group">
							<input
								id='carga_horaria_realizada_horas'
								name='carga_horaria_realizada_horas'
								type='number'
								required
								className='form-control'
							/>

							<span className="input-group-text">:</span>

							<input
								id='carga_horaria_realizada_minutos'
								name='carga_horaria_realizada_minutos'
								type='number'
								max={59}
								min={0}
								required
								className='form-control'
							/>
						</div>
					</div>
				</div>
			</div>

			<input id="realizacao_estagio_form_reset" type='reset' style={{ display: 'none' }} />
			<input id="realizacao_estagio_form_submit" type='submit' style={{ display: 'none' }} />
		</form>
	);
});

RealizacaoForm.displayName = 'RealizacaoForm';

export default RealizacaoForm;
